import React from 'react'
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Minted from './pages/Minted';
import Dashboard from './pages/Dashboard'

const Pages = () => {
  return (
    <Routes>
      <Route path = '/' element={<Home />} />
      <Route path = '/about' element={<About />} />
      <Route path='/minted' element={<Minted/>} />
      <Route path='/dashboard' element={<Dashboard/>} />
    </Routes>
  )
}


export default Pages

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */
